import React, { Component, Fragment, createRef } from 'react'
import moment from 'moment'
import { Form, Modal, Spin, message } from 'antd'
import _ from 'lodash'
import $, { data } from 'jquery'
import styles from './styles.module.scss'
import AppHelper from 'libs/AppHelper'
import { API_HOST } from '../../configs/env'
import whttp from '../../libs/whttp'
import { __ } from '@wordpress/i18n'

const VC_CONFIG = _.get(window, 'VC_CONFIG', {})
const Local = _.get(window, 'VC_CONFIG.Locale')
const defaultListInfo = {
  current: 1, //目前頁數
  page_size: 10, //一頁幾筆
  total: 1, //以此query條件，總共幾筆資料
  rows: [],
}

// 消費日期: pur_dt (all)
// 分店名稱: pur_store (all)
// 交易型態: pur_trantypeid
// 消費金額: pur_amount (all)
// 紅利折抵: pur_discount
// 獲得點數: pur_accounts[0].earnValue
// 發票號碼: einvoice_no
// 是否列印發票: einvoice_type
// 是否中獎: einvoice_type

// 前端頁面
export default class UserPaymentOca extends Component {
  cancelList = []

  state = {
    query: {
      start_dt: '',
      end_dt: '',
    },
    tableData: [],
    tableData_Detail: [],
    selectmonth: moment()
      .startOf('month')
      .format('YYYY-MM-DD'),
    startMonth: moment()
      .startOf('month')
      .format('YYYY-MM-DD'),
    endMonth: moment(
      moment()
        .startOf('month')
        .format('YYYY-MM-DD')
    )
      .add(1, 'months')
      .format('YYYY-MM-DD'),
    paymentInfo: undefined,
    purLoading: true,
    memberVip: '',
    memberLinkcode: '',
    bonusPoint: 0,
    bonusPointDiscount: 0,
    detailData: [],
    activityPoint: [],
  }

  componentDidMount() {
    var date = new Date()
    var y = date.getFullYear()
    var m = date.getMonth()
    var firstDay = new Date(y, m, 1)
    var lastDay = new Date(y, m + 1, 0)
    const query = {
      start_dt: moment(firstDay).format('YYYY-MM-DD'),
      end_dt: moment(lastDay).format('YYYY-MM-DD'),
    }
    this.setState({ query })
    this.setState({ info: this.props.user }, () => {
      this.reloadTab()
    })
    this.getMemberProfile()
    this.getPointList(query)
    this.loadData(query)
    this.control()
  }

  control = () => {
    $(document).ready(function() {
      $(document).on(
        'show.bs.collapse',
        '.tbody .order-detail-info',
        function() {
          $('.order-detail-info').removeClass('show')
        }
      )
    })
  }

  getMemberProfile = () => {
    whttp.get(API_HOST + `/api/account/oca/getProfiles`, {}, (state, res) => {
      const { code = 100, reason = '發生錯誤', data = {} } = res
      if (code !== 200) {
        Modal.error({
          title: '資料讀取失敗',
          content: reason,
        })
      }

      this.setState({
        memberVip: data.member_profile_isvip === 0 ? '一般會員' : 'VIP',
        memberLinkcode: data.member_profile_linkcode,
        bonusPoint: parseInt(data.member_account_value, 10),
        bonusPointDiscount: parseInt(data.member_account_value / 300, 10),
      })
    })
  }

  getPointList = ({ start_dt = '', end_dt = '' }) => {
    this.setState({ purLoading: true })
    whttp.get(
      API_HOST +
        `/api/account/oca/getpointlist?start_dt=${start_dt}&end_dt=${end_dt}`,
      null,
      (state, res) => {
        this.setState({ purLoading: false })
        const { code = 100, reason = '發生錯誤', data = [] } = res
        if (state === false) {
          return message.error('發生錯誤')
        }
        // if (code !== 200) {
        //   return message.error(reason);
        // }
        if (code === 997) {
          $('#exampleModalCenter').modal('show')
        }
        const dataAllStores = data
          .filter((obj) => obj.storeName === 'All Stores')
          .map((obj) => {
            const date = obj.transactionTime.split(' ')
            return {
              ...obj,
              pur_dt: date[0],
              pur_store: obj.storeName,
              pur_trantypeid: obj.posId,
              pur_remarks: obj.remarks,
              pur_amount: '',
              pur_accounts: [
                {
                  earnValue: obj.earnValue,
                  redeemValue: obj.redeemValue,
                },
              ],
              einvoice_no: '',
              einvoice_type: '',
              pur_id: obj.transactionId,
              pur_tenders: [],
              pur_transactionTime: obj.transactionTime,
              isLoaded: true,
            }
          })

        this.setState({ activityPoint: dataAllStores })
      }
    )
  }

  reloadTab = () => {
    // tab 共用動態
    var $el, leftPos, newWidth
    /* Add Magic Line markup via JavaScript, because it ain't gonna work without */
    let $magicLine = $('#magic-line')

    if (!_.get($magicLine, 0)) {
      $('.basic-tabs-label ul').append("<li id='magic-line'></li>")
    }
    /* Cache it */
    $magicLine = $('#magic-line')

    $magicLine
      .width($('.current_page_item').width())
      .css('left', $('.current_page_item a').position().left)
      .data('origLeft', $magicLine.position().left)
      .data('origWidth', $magicLine.width())

    $('.basic-tabs-label ul li a').unbind('mouseenter mouseleave')
    $('.basic-tabs-label ul li')
      .find('a')
      .hover(
        function() {
          $el = $(this)
          console.log('basic-tabs-label', $el)
          leftPos = $el.position().left
          newWidth = $el.parent().width()

          $magicLine.stop().animate({
            left: leftPos,
            width: newWidth,
          })
        },
        function() {
          $magicLine.stop().animate({
            left: $magicLine.data('origLeft'),
            width: $magicLine.data('origWidth'),
          })
        }
      )

    $('#pills-tab .nav-item').unbind('mouseenter mouseleave')
    $('#pills-tab .nav-item')
      .mouseenter(function() {
        if (!$(this).hasClass('highlight')) {
          $('.highlight').removeClass('current_page_item')
        }
      })
      .mouseleave(function() {
        $('.highlight').addClass('current_page_item')
      })
  }

  loadData = (query = {}) => {
    console.log('loadData', this.cancelList)
    this.setState({ purLoading: true })
    whttp.post(
      API_HOST +
        `/api/account/oca/purchaseListV2?start_dt=${query.start_dt}&end_dt=${
          query.end_dt
        }`,
      null,
      (state, res) => {
        this.setState({ purLoading: false })
        const { code = 100, reason = '發生錯誤', data = [] } = res
        if (state === false) {
          return message.error('發生錯誤')
        }
        // if (code !== 200) {
        //   return message.error(reason);
        // }
        // 這邊把tableData先記錄下來
        // loadDetailData的時候再塞回去
        // 預設都沒有載入過Detail
        _.forEach(data, (item) => (item.isLoaded = false))
        this.setState({ tableData: data, purLoading: false }, () => {
          this.refreshPicker()
          this.cancelList.length > 0 &&
            this.cancelList.forEach((cancelFn) => {
              console.log('1')
              cancelFn()
            })
          for (let i = 0; i < data.length; i++) {
            this.loadDetailData(query, data, i)
          }
        })
      }
    )
  }

  loadDetailData = (query = {}, tableData, i) => {
    const transactionId = _.get(tableData, `${i}.pur_id`)
    const storeId = _.get(tableData, `${i}.pur_storeId`)
    const posId = _.get(tableData, `${i}.pur_posId`)
    const businessDate = _.get(tableData, `${i}.pur_dt`)
    let detailData = _.get(this, 'state.detailData')
    const cancelToken = whttp.post(
      API_HOST +
        `/api/account/oca/purchaseDetail?start_dt=${query.start_dt}&end_dt=${
          query.end_dt
        }&transactionId=${transactionId}&storeId=${storeId}&posId=${posId}&businessDate=${businessDate}`,
      null,
      (state, res) => {
        this.setState({ purLoading: false })
        const { code = 100, reason = '發生錯誤', data = {} } = res
        if (state === false) {
          return message.error('發生錯誤')
        }
        if (code !== 200) {
          return message.error(reason)
        }
        const tableData = _.get(this, 'state.tableData')

        // 找到tableData中的資料
        const record = _.find(tableData, (item) => {
          return parseInt(item.id, 10) === parseInt(data.id, 10)
        })
        // 處理資料合併，把detail資料合併到record
        _.assign(record, data)

        if (!record) {
          return this.setState({
            message: '沒有資料',
          })
        }
        record.isLoaded = true
        this.setState({ tableData })
      }
    )
    this.cancelList.push(cancelToken)
  }

  refreshPicker = _.debounce(() => {
    $('.selectpicker').selectpicker('refresh')
  }, 1000)

  wincode = (num) => {
    var codeA = '特別獎 1000萬'
    var codeB = '千元獎 2000元'
    var codeC = '百萬獎 100萬'
    var code = [
      '特　獎 200萬',
      '頭　獎 20萬',
      '二　獎 <br> 4萬',
      '三　獎 <br> 1萬',
      '四　獎 4,000元',
      '五　獎 1,000元',
      '六　獎 200元',
    ]
    if (num === 'A') {
      return codeA || '??'
    } else if (num === 'B') {
      return codeB || '??'
    } else if (num === 'C') {
      return codeC || '??'
    } else {
      num = parseInt(num, 10)
      return code[num] || '??'
    }
  }

  nonwincode = (selectmonth) => {
    if (selectmonth) {
      var getDate = moment(selectmonth)
      var currDate = moment()

      if (moment(getDate).isBefore(currDate)) {
        var getDateMonth = getDate.format('M')
        var currDateMonth = currDate.format('M')
        var currDateDay = currDate.format('D')
        var diffMonth = Math.abs(currDateMonth - getDateMonth)

        if (currDateMonth >= 7) {
          //7-12月
          if (diffMonth > 2) {
            if (localStorage.getItem('setlang') == 'en') {
              return "Didn't win a Prize"
            } else {
              return '已開獎'
            }
          } else {
            if (currDateMonth % 2 == 0) {
              //偶數月
              if (diffMonth > 1) {
                if (localStorage.getItem('setlang') == 'en') {
                  return "Didn't win a Prize"
                } else {
                  return '已開獎'
                }
              } else {
                if (localStorage.getItem('setlang') == 'en') {
                  return '未開獎'
                } else {
                  return '未開獎'
                }
              }
            } else {
              //開獎月(奇數月)
              if (diffMonth == 0) {
                if (localStorage.getItem('setlang') == 'en') {
                  return '未開獎'
                } else {
                  return '未開獎'
                }
              } else {
                if (currDateDay > 25) {
                  // 已開獎
                  if (localStorage.getItem('setlang') == 'en') {
                    return "Didn't win a Prize"
                  } else {
                    return '已開獎'
                  }
                } else {
                  if (localStorage.getItem('setlang') == 'en') {
                    return '未開獎'
                  } else {
                    return '未開獎'
                  }
                }
              }
            }
          }
        } else {
          if (diffMonth > 2 && diffMonth < 10) {
            if (localStorage.getItem('setlang') == 'en') {
              return "Didn't win a Prize"
            } else {
              return '已開獎'
            }
          } else {
            if (currDateMonth % 2 == 0) {
              //偶數月
              if (diffMonth <= 1) {
                if (localStorage.getItem('setlang') == 'en') {
                  return '未開獎'
                } else {
                  return '未開獎'
                }
              } else {
                if (localStorage.getItem('setlang') == 'en') {
                  return "Didn't win a Prize"
                } else {
                  return '已開獎'
                }
              }
            } else {
              //開獎月(奇數月)
              if (diffMonth == 0) {
                if (localStorage.getItem('setlang') == 'en') {
                  return '未開獎'
                } else {
                  return '未開獎'
                }
              } else {
                if (currDateDay > 25) {
                  // 已開獎
                  if (localStorage.getItem('setlang') == 'en') {
                    return "Didn't win a Prize"
                  } else {
                    return '已開獎'
                  }
                } else {
                  if (localStorage.getItem('setlang') == 'en') {
                    return '未開獎'
                  } else {
                    return '未開獎'
                  }
                }
              }
            }
          }
        }
      } else {
        if (localStorage.getItem('setlang') == 'en') {
          return '無法判斷'
        } else {
          return '無法判斷'
        }
      }
    } else {
      if (localStorage.getItem('setlang') == 'en') {
        return '無法判斷'
      } else {
        return '無法判斷'
      }
    }
  }

  selectChange = (e) => {
    const { query } = this.state
    query.start_dt = e.target.value
    query.end_dt = moment(e.target.value)
      .endOf('month')
      .format('YYYY-MM-DD')
    const startMonth = e.target.value.replace(/-/g, '/')
    const endMonth = moment(startMonth)
      .add(1, 'months')
      .format('YYYY-MM-DD')
    this.setState({
      selectmonth: e.target.value,
      startMonth,
      endMonth,
      detailData: [],
      tableData: [],
      activityPoint: [],
    })
    this.loadData(query)
    this.getPointList(query)
  }

  render() {
    console.log(this.cancelList)
    const { info, tableData = [], activityPoint = [] } = this.state
    const mixTableData = [...tableData, ...activityPoint].sort((a, b) =>
      new Date(a.pur_dt) > new Date(b.pur_dt) ? -1 : 1
    )
    const MemberVip = this.state.memberVip
    const MemberLinkcode = this.state.memberLinkcode
    const BonusPoint = this.state.bonusPoint
    const BonusPointDiscount = this.state.bonusPointDiscount
    const selectmonth = this.state.selectmonth
    const diffdd = this.nonwincode(selectmonth)
    var date = new Date()
    var y = date.getFullYear()
    var m = date.getMonth()
    var firstDay = new Date(y, m, 1)
    var lastDay = new Date(y, m + 1, 0)
    var areaMonth = {
      month: [moment(firstDay).format('YYYY-MM-DD')],
      value: [moment(firstDay).format('YYYY年MM月')],
    }
    for (let i = 0; i < 5; i++) {
      areaMonth.month.push(
        moment(firstDay)
          .subtract(1, 'months')
          .format('YYYY-MM-DD')
      )
      areaMonth.value.push(
        moment(firstDay)
          .subtract(1, 'months')
          .format('YYYY年MM月')
      )
      firstDay = moment(firstDay)
        .subtract(1, 'months')
        .format('YYYY-MM-DD')
      lastDay = moment(lastDay)
        .subtract(1, 'months')
        .format('YYYY-MM-DD')
    }

    this.refreshPicker()

    return (
      <div>
        <main className='bg-light'>
          {/* <!-- Modal --> */}
          <div
            class='modal fade'
            id='exampleModalCenter'
            tabindex='-1'
            role='dialog'
            aria-labelledby='exampleModalCenterTitle'
            aria-hidden='true'>
            <div
              style={{ justifyContent: 'center' }}
              class='modal-dialog modal-dialog-centered'
              role='document'>
              <div
                style={{ width: '355px', height: '200px' }}
                class='modal-content'>
                <div
                  style={{
                    padding: '1rem',
                    margin: 'auto',
                    borderBottom: '0px',
                  }}
                  class='modal-header'>
                  <h5 class='modal-title' id='exampleModalCenterTitle'>
                    目前會員系統維護中，暫時無法更新會員個資、查詢點數、交易及發票等，造成不便之處，敬請見諒！
                  </h5>
                </div>
                <div className={styles.container}>
                  <button
                    style={{
                      backgroundColor: '#0072E3',
                      color: 'white',
                      width: '120px',
                      height: '41px',
                      border: '0.65rem',
                    }}
                    type='button'
                    class='btn btn-secondary'
                    data-dismiss='modal'>
                    確認
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- Modal --> */}
          <div className='container'>
            <section className='pt-2 pb-2'>
              <div className='breadcrumb-wrap'>
                <nav aria-label='breadcrumb'>
                  <ol className='breadcrumb'>
                    <li className='breadcrumb-item'>
                      <a
                        href={`${VC_CONFIG.INDEX_URL}/${
                          Local == 'en_US' ? 'en' : ''
                        }`}>
                        {__('首頁', 'cec-plugin-stores')}
                      </a>
                    </li>
                    <li className='breadcrumb-item'>
                      <a
                        href={`${VC_CONFIG.INDEX_URL}/profile${
                          Local == 'en_US' ? '-en' : ''
                        }`}>
                        {__('會員中心', 'cec-plugin-stores')}
                      </a>
                    </li>
                    {/* <li className='breadcrumb-item active' aria-current='page'>
                      {__('我的消費紀錄', 'cec-plugin-stores')}
                    </li> */}
                  </ol>
                </nav>
              </div>
              <h6 className='h5 lh-h4 mb-5 text-navy text-lg-left text-center'>
                {__('親愛的', 'cec-plugin-stores')}{' '}
                <b className='fw-700'>{info && info.name}</b>
                <br className='d-block d-lg-none' />
                {__('您好，歡迎來到會員中心！', 'cec-plugin-stores')}
              </h6>
              <div class='row no-gutters mx-n3 mb-4'>
                <div
                  class='col-lg-28 px-3'
                  style={{
                    flexGrow: 0,
                    flexShrink: 0,
                    flexBasis: 'calc((100% / 7) * 2)',
                    maxWidth: 'calc((100% / 7) * 2)',
                  }}>
                  <div class='card border-0 shadow-0 h-100'>
                    <div class='card-body justify-content-center align-items-center pb-0 pt-5 p-lg-5'>
                      <div
                        class='hkcardontop'
                        style={{
                          textAlign: 'center',
                        }}>
                        {MemberVip == 'VIP' ? (
                          <img
                            style={{
                              maxWidth: '180px',
                            }}
                            className='img-contain'
                            src={`${
                              VC_CONFIG.INDEX_URL
                            }/wp-content/themes/cec/assets/img/membercard/2021VIPcard.png`}
                            alt=''
                          />
                        ) : (
                          <img
                            style={{
                              maxWidth: '180px',
                            }}
                            className='img-contain'
                            src={`${
                              VC_CONFIG.INDEX_URL
                            }/wp-content/themes/cec/assets/img/membercard/newHKcard.png`}
                            alt=''
                          />
                        )}
                      </div>
                      {/*<h5 class="h3 text-navy text-center pt-3">好康卡</h5>*/}
                    </div>
                  </div>
                </div>
                <div
                  class='col-lg-71 px-3'
                  style={{
                    flexGrow: 0,
                    flexShrink: 0,
                    flexBasis: 'calc((100% / 7) * 5)',
                    maxWidth: 'calc((100% / 7) * 5)',
                  }}>
                  <div class='card border-0 shadow-0 h-100'>
                    <div class='card-body'>
                      <ul class='h6 text-navy text-justify list-unstyled'>
                        <li class='pb-1'>會員等級：{MemberVip}</li>
                        {/* <li class='pb-1'>
                          會員卡號：
                          {MemberLinkcode}
                        </li> */}
                        <li class='pb-1'>好康點數：{BonusPoint}點</li>
                        <li class='pb-1'>
                          可兌換金額：
                          {BonusPointDiscount}元
                        </li>
                      </ul>
                      <p class='h6 pt-4 text-font text-justify'>
                        *顯示之點數視消費情況更新！如遇資料交換造成點數延遲異動，以電腦系統為準。
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <section className='pt-0'>
            <div className='mb-5 basic-tabs-label'>
              <ul className='nav nav-pills' id='pills-tab'>
                <li className='nav-item'>
                  <a
                    className='nav-link'
                    href={`${VC_CONFIG.INDEX_URL}/profile${
                      Local == 'en_US' ? '-en' : ''
                    }`}>
                    {__('我的帳戶', 'cec-plugin-stores')}
                  </a>
                </li>
                <li className='nav-item'>
                  <a
                    className='nav-link'
                    href={`${VC_CONFIG.INDEX_URL}/pwd${
                      Local == 'en_US' ? '-en' : ''
                    }`}>
                    {__('更改密碼', 'cec-plugin-stores')}
                  </a>
                </li>
                {/* <li className='nav-item current_page_item highlight'>
                  <a className='nav-link'>
                    {__('我的消費紀錄', 'cec-plugin-stores')}
                  </a>
                </li> */}
                <li className='nav-item'>
                  <a
                    className='nav-link'
                    href={`${
                      VC_CONFIG.INDEX_URL
                    }/einvoice-carrier-consolidation${
                      Local == 'en_US' ? '-en' : ''
                    }`}>
                    {__('發票歸戶', 'cec-plugin-stores')}
                  </a>
                </li>
              </ul>
            </div>
            {/* 手機板 */}
            <div className='container d-lg-none'>
              <div className='card shadow-5 rounded-20 border-0 mb-4'>
                <div className='card-body'>
                  <div className='row align-items-center mb-4'>
                    <div className='col-auto'>
                      <h6 className='h6 text-navy mb-0'>
                        {__('查詢月份', 'cec-plugin-stores')}
                      </h6>
                    </div>
                    <div className='col'>
                      <select
                        className='form-select border border-primary mb-md-0 mb-4'
                        name='SelectMonth'
                        id='SelectMonth'
                        value={this.state.selectmonth}
                        onChange={this.selectChange}>
                        <option value={areaMonth.month[0]}>
                          {areaMonth.value[0]}
                        </option>
                        <option value={areaMonth.month[1]}>
                          {areaMonth.value[1]}
                        </option>
                        <option value={areaMonth.month[2]}>
                          {areaMonth.value[2]}
                        </option>
                        <option value={areaMonth.month[3]}>
                          {areaMonth.value[3]}
                        </option>
                        <option value={areaMonth.month[4]}>
                          {areaMonth.value[4]}
                        </option>
                        <option value={areaMonth.month[5]}>
                          {areaMonth.value[5]}
                        </option>
                      </select>
                    </div>
                  </div>
                  <p className='p text-navy mb-0'>
                    {__(
                      '網站僅提供六個月內消費紀錄查詢，若您對您的消費記錄有任何疑問，可以撥打客服專線：0809-001-365 查詢！',
                      'cec-plugin-stores',
                    )}
                  </p>
                </div>
              </div>
              <div className='mb-5'>
                <Spin spinning={this.state.purLoading}>
                  {mixTableData.length === 0 && (
                    <div
                      className='card-record-list-mobile card shadow-5 rounded-20 border-0 mb-3'
                      data-toggle='collapse'
                      href='#order-detail-m-1'
                      role='button'
                      aria-expanded='false'
                      aria-controls='order-detail-m-1'>
                      <div className='card-body'>
                        <div
                          className='row align-items-center'
                          style={{
                            'text-align': 'center',
                          }}>
                          <h6
                            className='h6 text-navy mb-0'
                            style={{
                              width: '100%',
                            }}>
                            {__('尚無任何消費記錄', 'cec-plugin-stores')}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}
                  {mixTableData.length !== 0 &&
                    _.map(mixTableData, (v) => {
                      const purAccounts = v['pur_accounts'] || []
                      const purTenders = v['pur_tenders'] || []
                      const purItems = v['pur_items'] || []
                      const purNetAmount = v['pur_netamount'] || [] // 小計
                      const purTotalamount = parseInt(
                        _.get(v, 'pur_totalamount', []),
                        10,
                      ) // 總計

                      const purDiscount = _.get(v, 'pur_discount', 0)
                        ? parseInt(_.get(v, 'pur_discount', []), 10)
                        : '' // 紅利折抵
                      // 紅利點數
                      const BonusPointEarnValue = _.get(
                        purAccounts,
                        '0.earnValue',
                        0,
                      )
                        ? _.get(purAccounts, '0.earnValue', [])
                        : '' // __('暫無資料','cec-plugin-stores')
                      const BonusPointBalance = _.get(
                        purAccounts,
                        '0.balance',
                        [],
                      )
                        ? _.get(purAccounts, '0.balance', [])
                        : ''
                      const BonusPointDiscount = parseInt(
                        BonusPointBalance / 300,
                        10,
                      )
                      const BonusPointRedeemValue = _.get(
                        purAccounts,
                        '0.redeemValue',
                        [],
                      )
                        ? parseInt(
                            _.get(purAccounts, '0.redeemValue', []),
                            10,
                          )
                        : 0
                      const BonusPointEarnAmount = _.get(
                        purTenders,
                        '1.amount',
                        [],
                      )
                        ? parseInt(_.get(purTenders, '1.amount', []), 10)
                        : __('-', 'cec-plugin-stores')
                      return (
                        <div>
                          <div>
                            {/* {v.isLoaded === false && '讀取中'} */}
                            <div
                              className='card-record-list-mobile card shadow-5 rounded-20 border-0 mb-3'
                              data-toggle='collapse'
                              href={`#order-detail-m-${v.pur_id}`}
                              role='button'
                              aria-expanded='false'
                              aria-controls={`#order-detail-m-${v.pur_id}`}>
                              <div className='card-body'>
                                <div className='row align-items-center'>
                                  <div className='col-auto'>
                                    {/* test */}
                                    <h6 className='h6 text-navy mb-0'>
                                      {v.pur_dt}
                                    </h6>
                                  </div>
                                  <div className='col'>
                                    <h6 className='h6 text-navy mb-0'>
                                      {!v.pur_store
                                        ? __(
                                            '店外消費',
                                            'cec-plugin-stores',
                                          )
                                        : v.pur_store === 'All Stores'
                                        ? __('總公司', 'cec-plugin-stores')
                                        : v.pur_store}
                                    </h6>
                                  </div>
                                  <div className='col-auto'>
                                    <h6 className='h6 text-primary mb-0'>
                                      {Local === 'en_US' &&
                                        v.pur_amount &&
                                        `$${v.pur_amount}`}
                                      {Local === 'zh_TW' &&
                                        v.pur_amount &&
                                        `${v.pur_amount}元`}
                                      {Local === 'en_US' &&
                                        v.pur_amount === '' &&
                                        __('-', 'cec-plugin-stores')}
                                      {Local === 'en_US' &&
                                        v.pur_amount === 0 &&
                                        __('-', 'cec-plugin-stores')}
                                    </h6>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className='card-record-info-mobile collapse'
                              id={`order-detail-m-${v.pur_id}`}>
                              <div className='card shadow-5 rounded-20 border-0 mb-4'>
                                <div className='card-body'>
                                  <h6 className='h6 text-primary my-4'>
                                    {__('交易明細', 'cec-plugin-stores')}
                                  </h6>
                                  <div className='row align-items-center mb-4'>
                                    <div className='col-6'>
                                      <p className='p text-navy mb-0'>
                                        {__(
                                          '消費日期',
                                          'cec-plugin-stores',
                                        )}
                                      </p>
                                    </div>
                                    <div className='col-6 text-right border-left border-gary'>
                                      <p className='p text-primary d-flex align-items-center justify-content-end mb-0'>
                                        <span className='d-inline-block'>
                                          {v.pur_dt}
                                        </span>
                                      </p>
                                    </div>
                                  </div>
                                  <div className='row align-items-center mb-4'>
                                    <div className='col-6'>
                                      <p className='p text-navy mb-0'>
                                        {__(
                                          '分店名稱',
                                          'cec-plugin-stores',
                                        )}
                                      </p>
                                    </div>
                                    <div className='col-6 text-right border-left border-gary'>
                                      <p className='p text-primary d-flex align-items-center justify-content-end mb-0'>
                                        <span className='d-inline-block'>
                                          {!v.pur_store
                                            ? __(
                                                '店外消費',
                                                'cec-plugin-stores',
                                              )
                                            : v.pur_store === 'All Stores'
                                            ? __(
                                                '總公司',
                                                'cec-plugin-stores',
                                              )
                                            : v.pur_store}
                                        </span>
                                      </p>
                                    </div>
                                  </div>
                                  <div className='row align-items-center mb-4'>
                                    <div className='col-6'>
                                      <p className='p text-navy mb-0'>
                                        {__(
                                          '交易型態',
                                          'cec-plugin-stores',
                                        )}
                                      </p>
                                    </div>
                                    <div className='col-6 text-right border-left border-gary'>
                                      <p className='p text-primary d-flex align-items-center justify-content-end mb-0'>
                                        <span className='d-inline-block'>
                                          {v.pur_trantypeid === '20' &&
                                            __('消費', 'cec-plugin-stores')}
                                          {v.pur_trantypeid === '23' &&
                                            __('退費', 'cec-plugin-stores')}
                                          {v.pur_trantypeid === -66 &&
                                            __(
                                              '點數調整',
                                              'cec-plugin-stores',
                                            )}
                                        </span>
                                      </p>
                                    </div>
                                  </div>
                                  <div className='row align-items-center mb-4'>
                                    <div className='col-6'>
                                      <p className='p text-navy mb-0'>
                                        {__(
                                          '是否列印發票',
                                          'cec-plugin-stores',
                                        )}
                                      </p>
                                    </div>
                                    <div className='col-6 text-right border-left border-gary'>
                                      <p className='p text-primary d-flex align-items-center justify-content-end mb-0'>
                                        <span className='d-inline-block'>
                                          {v.isLoaded !== true &&
                                            __('', 'cec-plugin-stores')}
                                          {v.einvoice_type === '2' &&
                                            __(
                                              '電子發票',
                                              'cec-plugin-stores',
                                            )}
                                          {/* __('非歸戶發票','cec-plugin-stores') */}
                                          {v.einvoice_type !== '2' &&
                                            v.einvoice_type !== '' &&
                                            __(
                                              '紙本發票',
                                              'cec-plugin-stores',
                                            )}
                                          {v.einvoice_type !== '2' &&
                                            v.einvoice_type === '' &&
                                            v.isLoaded === true &&
                                            __('-', 'cec-plugin-stores')}
                                        </span>
                                      </p>
                                    </div>
                                  </div>
                                  <div className='row align-items-center mb-4'>
                                    <div className='col-6'>
                                      <p className='p text-navy mb-0'>
                                        {__(
                                          '是否中獎',
                                          'cec-plugin-stores',
                                        )}
                                      </p>
                                    </div>
                                    <div className='col-6 text-right border-left border-gary'>
                                      <p className='p text-primary d-flex align-items-center justify-content-end mb-0'>
                                        <span className='d-inline-block'>
                                          {diffdd === '未開獎' &&
                                            v.einvoice_type === '2' &&
                                            __(
                                              '未開獎',
                                              'cec-plugin-stores',
                                            )}
                                          {diffdd === '未開獎' &&
                                            v.einvoice_type === '3' &&
                                            __(
                                              '請自行對獎',
                                              'cec-plugin-stores',
                                            )}
                                          {v.isLoaded !== true &&
                                            __('', 'cec-plugin-stores')}
                                          {v.einvoice_type === '' &&
                                            __('-', 'cec-plugin-stores')}
                                          {diffdd === '已開獎' &&
                                            v.einvoice_type === '3' &&
                                            __(
                                              '請自行對獎',
                                              'cec-plugin-stores',
                                            )}
                                          {diffdd === '已開獎' &&
                                            v.isLoaded === true &&
                                            v.einvoice_type === '2' &&
                                            v.win === '' &&
                                            __(
                                              '未中獎',
                                              'cec-plugin-stores',
                                            )}
                                          {diffdd === '已開獎' &&
                                            v.isLoaded === true &&
                                            v.einvoice_type === '2' &&
                                            v.win === 'B' &&
                                            __(
                                              '無實體發票專屬獎',
                                              'cec-plugin-stores',
                                            )}
                                          {diffdd === '已開獎' &&
                                            v.isLoaded === true &&
                                            v.einvoice_type === '2' &&
                                            v.win === 'C' &&
                                            __(
                                              '無實體百萬元獎',
                                              'cec-plugin-stores',
                                            )}
                                          {diffdd === '已開獎' &&
                                            v.isLoaded === true &&
                                            v.einvoice_type === '2' &&
                                            v.win === 'A' &&
                                            __(
                                              '特別獎',
                                              'cec-plugin-stores',
                                            )}
                                          {diffdd === '已開獎' &&
                                            v.isLoaded === true &&
                                            v.einvoice_type === '2' &&
                                            v.win === '0' &&
                                            __('特獎', 'cec-plugin-stores')}
                                          {diffdd === '已開獎' &&
                                            v.isLoaded === true &&
                                            v.einvoice_type === '2' &&
                                            v.win === '1' &&
                                            __('頭獎', 'cec-plugin-stores')}
                                          {diffdd === '已開獎' &&
                                            v.isLoaded === true &&
                                            v.einvoice_type === '2' &&
                                            v.win === '2' &&
                                            __('二獎', 'cec-plugin-stores')}
                                          {diffdd === '已開獎' &&
                                            v.isLoaded === true &&
                                            v.einvoice_type === '2' &&
                                            v.win === '3' &&
                                            __('三獎', 'cec-plugin-stores')}
                                          {diffdd === '已開獎' &&
                                            v.isLoaded === true &&
                                            v.einvoice_type === '2' &&
                                            v.win === '4' &&
                                            __('四獎', 'cec-plugin-stores')}
                                          {diffdd === '已開獎' &&
                                            v.isLoaded === true &&
                                            v.einvoice_type === '2' &&
                                            v.win === '5' &&
                                            __('五獎', 'cec-plugin-stores')}
                                          {diffdd === '已開獎' &&
                                            v.isLoaded === true &&
                                            v.einvoice_type === '2' &&
                                            v.win === '6' &&
                                            __('六獎', 'cec-plugin-stores')}
                                        </span>
                                      </p>
                                    </div>
                                  </div>
                                  <div className='row align-items-center mb-4'>
                                    <div className='col-6'>
                                      <p className='p text-navy mb-0'>
                                        {__(
                                          '發票捐贈',
                                          'cec-plugin-stores',
                                        )}
                                      </p>
                                    </div>
                                    <div className='col-6 text-right border-left border-gary'>
                                      <p className='p text-primary d-flex align-items-center justify-content-end mb-0'>
                                        <span className='d-inline-block'>
                                          {![2, 3].includes(
                                            parseInt(v.einvoice_type, 10),
                                          ) ? (
                                            '-'
                                          ) : (
                                            <Fragment>
                                              {v.donation === 1
                                                ? __(
                                                    '有',
                                                    'cec-plugin-stores',
                                                  )
                                                : __(
                                                    '無',
                                                    'cec-plugin-stores',
                                                  )}
                                            </Fragment>
                                          )}
                                        </span>
                                      </p>
                                    </div>
                                  </div>
                                  <div className='row align-items-center mb-4'>
                                    <div className='col-6'>
                                      <p className='p text-navy mb-0'>
                                        {__('備註', 'cec-plugin-stores')}
                                      </p>
                                    </div>
                                    <div className='col-6 text-right border-left border-gary'>
                                      <p className='p text-primary d-flex align-items-center justify-content-end mb-0'>
                                        {v.pur_remarks !== '' &&
                                          v.pur_remarks}
                                        {v.pur_remarks === '' &&
                                          __('-', 'cec-plugin-stores')}
                                      </p>
                                    </div>
                                  </div>
                                  <hr className='my-5' />
                                  <h6 className='h6 text-primary my-4'>
                                    {__('商品', 'cec-plugin-stores')}
                                  </h6>
                                  {_.map(purItems, (item) => {
                                    const itemName = _.get(
                                      item,
                                      'itemName',
                                      [],
                                    )
                                    const qty = _.get(item, 'qty', [])
                                    return (
                                      <div className='row align-items-center mb-4'>
                                        <div className='col-6'>
                                          <p className='p text-navy mb-0'>
                                            {itemName}
                                          </p>
                                        </div>
                                        <div className='col-3 text-right border-left border-gary'>
                                          <p className='p text-primary mb-0'>
                                            {qty}
                                          </p>
                                        </div>
                                        <div className='col-3 text-right border-left border-gary'>
                                          <p className='p text-primary mb-0'>
                                            ${_.get(item, 'amount', 0)}
                                          </p>
                                        </div>
                                      </div>
                                    )
                                  })}
                                  <hr className='my-5' />
                                  <h6 className='h6 text-primary my-4'>
                                    {__('發票/金額', 'cec-plugin-stores')}
                                  </h6>
                                  <div className='row align-items-center mb-4'>
                                    <div className='col-6'>
                                      <p className='p text-navy mb-0'>
                                        {__(
                                          '發票號碼',
                                          'cec-plugin-stores',
                                        )}
                                      </p>
                                    </div>
                                    <div className='col-6 text-right border-left border-gary'>
                                      <p className='p text-primary d-flex align-items-center justify-content-end mb-0'>
                                        <span className='d-inline-block'>
                                          {v.einvoice_no !== '' &&
                                            v.einvoice_no}
                                          {v.einvoice_no === '' &&
                                            __('-', 'cec-plugin-stores')}
                                        </span>
                                      </p>
                                    </div>
                                  </div>
                                  <div className='row align-items-center mb-4'>
                                    <div className='col-6'>
                                      <p className='p text-navy mb-0'>
                                        {__('小計', 'cec-plugin-stores')}
                                      </p>
                                    </div>
                                    <div className='col-6 text-right border-left border-gary'>
                                      <p className='p text-primary d-flex align-items-center justify-content-end mb-0'>
                                        <span className='d-inline-block'>
                                          ${purNetAmount}
                                        </span>
                                      </p>
                                    </div>
                                  </div>
                                  {_.map(purTenders, (tender) => {
                                    return (
                                      <div className='row align-items-center mb-4'>
                                        <div className='col-6'>
                                          <p className='p text-navy mb-0'>
                                            {__(
                                              _.get(
                                                tender,
                                                'tenderName',
                                                '-',
                                              ),
                                              'cec-plugin-stores',
                                            )}
                                          </p>
                                        </div>
                                        <div className='col-6 text-right border-left border-gary'>
                                          <p className='p text-primary d-flex align-items-center justify-content-end mb-0'>
                                            <span className='d-inline-block'>
                                              $
                                              {_.toInteger(
                                                _.get(tender, 'amount', 0),
                                              )}
                                            </span>
                                          </p>
                                        </div>
                                      </div>
                                    )
                                  })}
                                  <hr className='my-5' />
                                  <h6 className='h6 text-primary my-4'>
                                    {__('點數', 'cec-plugin-stores')}
                                  </h6>
                                  <div className='row align-items-center mb-4'>
                                    <div className='col-6'>
                                      <p className='p text-navy mb-0'>
                                        {__(
                                          '本次扣抵',
                                          'cec-plugin-stores',
                                        )}
                                      </p>
                                    </div>
                                    <div className='col-6 text-right border-left border-gary'>
                                      <p className='p text-primary d-flex align-items-center justify-content-end mb-0'>
                                        <span className='d-inline-block text-danger'>
                                          {BonusPointRedeemValue}
                                          {BonusPointRedeemValue !== '' &&
                                            __('點', 'cec-plugin-stores')}
                                        </span>
                                        <span className='rounded-o rounded-red'>
                                          P
                                        </span>
                                      </p>
                                    </div>
                                  </div>
                                  <div className='row align-items-center mb-4'>
                                    <div className='col-6'>
                                      <p className='p text-navy mb-0'>
                                        {__(
                                          '本次回饋',
                                          'cec-plugin-stores',
                                        )}
                                      </p>
                                    </div>
                                    <div className='col-6 text-right border-left border-gary'>
                                      <p className='p text-primary d-flex align-items-center justify-content-end mb-0'>
                                        <span className='d-inline-block'>
                                          {BonusPointEarnValue}
                                          {BonusPointEarnValue !== '' &&
                                            __('點', 'cec-plugin-stores')}
                                          {v.isLoaded === true &&
                                            BonusPointEarnValue === '' &&
                                            __('-', 'cec-plugin-stores')}
                                        </span>
                                        <span className='rounded-o rounded-blue'>
                                          P
                                        </span>
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    })}
                  <div className='row mb-5 mt-4'>
                    <div className='col-8 col-md-3 mx-auto'>
                      <a
                        className='h6 btn btn-block btn-outline-primary rounded-pill py-4'
                        role='button'
                        href='#'>
                        看更多
                      </a>
                    </div>
                  </div>
                </Spin>
              </div>
              <div className='card shadow-5 rounded-20 border-0 mb-4'>
                <div className='card-body'>
                  <div className='row align-items-center mb-4'>
                    <div className='col-12'>
                      <h6 className='h5 text-navy text-center mb-4'>
                        {__('注意事項', 'cec-plugin-stores')}
                      </h6>
                    </div>
                    <div className='col-12'>
                      <p className='p text-navy mb-0'>
                        {__(
                          '如您發現姓名或生日與您申請資料不符，請與客服中心聯絡作資料的修改，以確保會員資料的正確性。',
                          'cec-plugin-stores',
                        )}
                      </p>
                      <p className='p text-navy mb-0'>
                        {__(
                          '客服中心：市話 0809-001-365 / 手機(02)8006-9999 ',
                          'cec-plugin-stores',
                        )}
                      </p>
                      <p className='p text-navy mb-0'>
                        {__(
                          '※ 由於促銷目錄為提前印製，故於網站更新個人地址後，目錄寄件資料更新約需30個工作天，造成您不便之處盼您見諒！！',
                          'cec-plugin-stores',
                        )}
                      </p>
                      <p className='p text-navy mb-0'>
                        {__(
                          '※ 如需取消促銷目錄寄送的服務，請與客服中心聯絡，將有專人為您提供服務。',
                          'cec-plugin-stores',
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* 電腦版 */}
            <div className='container d-none d-lg-block'>
              <div className='row no-gutters mx-n3 mb-4'>
                <div
                  className='col-lg-28 px-3'
                  style={{
                    flexGrow: 0,
                    flexShrink: 0,
                    flexBasis: 'calc((100% / 7) * 2)',
                    maxWidth: 'calc((100% / 7) * 2)',
                  }}>
                  <div className='card border-0 shadow-0 h-100'>
                    <div className='card-body d-flex justify-content-center align-items-center pb-0 pt-5 p-lg-5'>
                      <h5 class='h4 text-navy text-center'>
                        {__('查詢月份', 'cec-plugin-stores')}
                      </h5>
                    </div>
                  </div>
                </div>
                <div
                  className='col-lg-71 px-3'
                  style={{
                    flexGrow: 0,
                    flexShrink: 0,
                    flexBasis: 'calc((100% / 7) * 5)',
                    maxWidth: 'calc((100% / 7) * 5)',
                  }}>
                  <div className='card border-0 shadow-0 h-100'>
                    <div className='card-body p-5'>
                      <div className='row'>
                        <div className='col-md-3'>
                          <select
                            className='form-select border border-primary mb-md-0 mb-4'
                            name='SelectMonth'
                            id='SelectMonth'
                            value={this.state.selectmonth}
                            onChange={this.selectChange}>
                            <option value={areaMonth.month[0]}>
                              {areaMonth.value[0]}
                            </option>
                            <option value={areaMonth.month[1]}>
                              {areaMonth.value[1]}
                            </option>
                            <option value={areaMonth.month[2]}>
                              {areaMonth.value[2]}
                            </option>
                            <option value={areaMonth.month[3]}>
                              {areaMonth.value[3]}
                            </option>
                            <option value={areaMonth.month[4]}>
                              {areaMonth.value[4]}
                            </option>
                            <option value={areaMonth.month[5]}>
                              {areaMonth.value[5]}
                            </option>
                          </select>
                        </div>
                        <div className='col-md-9'>
                          <p className='p text-navy mb-0'>
                            {__(
                              '網站僅提供六個月內消費記錄查詢, 若您對您的消費記錄有任何疑問，可以撥打客服專線：0809-001-365 查詢！',
                              'cec-plugin-stores',
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='row no-gutters mx-n3 mb-4'>
                <div className='col-12 px-3'>
                  <div className='card border-0 shadow-0 h-100'>
                    <div className='card-body p-4 p-lg-0'>
                      <div className='flex-table' data-theme='primary'>
                        <div className='thead'>
                          <ul className='table-row'>
                            <li>{__('消費日期', 'cec-plugin-stores')}</li>
                            <li>{__('分店名稱', 'cec-plugin-stores')}</li>
                            <li>{__('交易型態', 'cec-plugin-stores')}</li>
                            <li>{__('消費金額', 'cec-plugin-stores')}</li>
                            <li>{__('紅利折抵', 'cec-plugin-stores')}</li>
                            <li>{__('獲得點數', 'cec-plugin-stores')}</li>
                            <li>{__('發票號碼', 'cec-plugin-stores')}</li>
                            <li>
                              {__('是否列印發票', 'cec-plugin-stores')}
                            </li>
                            <li>{__('是否中獎', 'cec-plugin-stores')}</li>
                          </ul>
                        </div>
                        <Spin spinning={this.state.purLoading}>
                          {mixTableData.length === 0 && (
                            <div className='tbody'>
                              <ul className='table-row order-detail-item'>
                                <li data-title='消費日期'>
                                  {__(
                                    '尚無任何消費記錄',
                                    'cec-plugin-stores',
                                  )}
                                </li>
                              </ul>
                            </div>
                          )}
                          {mixTableData.length !== 0 &&
                            _.map(mixTableData, (v) => {
                              const purAccounts = v['pur_accounts'] || []
                              const purTenders = v['pur_tenders'] || []
                              const purItems = v['pur_items'] || []
                              const purNetAmount = v['pur_netamount'] || []
                              const BonusPointEarnValue = purAccounts[0]
                                ? purAccounts[0].earnValue
                                : ''
                              const BonusPointBalance = _.get(
                                purAccounts,
                                '0.balance',
                                [],
                              )
                                ? _.get(purAccounts, '0.balance', [])
                                : 0
                              const BonusPointDiscount = parseInt(
                                BonusPointBalance / 300,
                                10,
                              )
                              const BonusPointRedeemValue = _.get(
                                purAccounts,
                                '0.redeemValue',
                                0,
                              )
                                ? parseInt(
                                    _.get(purAccounts, '0.redeemValue', 0),
                                    10,
                                  )
                                : 0
                              const BonusPointEarnAmount = _.get(
                                purTenders,
                                '1.amount',
                                [],
                              )
                                ? parseInt(
                                    _.get(purTenders, '1.amount', []),
                                    10,
                                  )
                                : __('-', 'cec-plugin-stores')
                              return (
                                <div>
                                  <div className='tbody'>
                                    <ul
                                      class='table-row order-detail-item'
                                      data-toggle='collapse'
                                      href={`#order-detail-${v.pur_id}`}
                                      role='button'
                                      aria-expanded='false'
                                      aria-controls={`#order-detail-${
                                        v.pur_id
                                      }`}
                                      id={v.pur_id}
                                      // onClick={() => this.clickgetdetail(v)}
                                    >
                                      <li
                                        data-title='消費日期'
                                        style={{
                                          textAlign: 'left',
                                        }}>
                                        {v.pur_dt}{' '}
                                        <Spin
                                          spinning={!v.isLoaded}
                                          size='small'
                                        />
                                      </li>
                                      <li
                                        className='d-none d-lg-block'
                                        data-title='分店名稱'>
                                        {!v.pur_store
                                          ? __(
                                              '店外消費',
                                              'cec-plugin-stores',
                                            )
                                          : v.pur_store === 'All Stores'
                                          ? __(
                                              '總公司',
                                              'cec-plugin-stores',
                                            )
                                          : v.pur_store}
                                      </li>
                                      <li
                                        className='d-none d-lg-block'
                                        data-title='交易型態'>
                                        {v.pur_trantypeid === '' &&
                                          __('-', 'cec-plugin-stores')}
                                        {v.pur_trantypeid === '20' &&
                                          __('消費', 'cec-plugin-stores')}
                                        {v.pur_trantypeid === '23' &&
                                          __('退費', 'cec-plugin-stores')}
                                        {v.pur_trantypeid === -66 &&
                                          __(
                                            '點數調整',
                                            'cec-plugin-stores',
                                          )}
                                      </li>
                                      <li data-title='消費金額'>
                                        {Local === 'en_US' &&
                                          v.pur_amount &&
                                          `$${v.pur_amount}`}
                                        {Local === 'zh_TW' &&
                                          v.pur_amount &&
                                          `${v.pur_amount}元`}
                                        {Local === 'zh_TW' &&
                                          v.pur_amount === '' &&
                                          __('-', 'cec-plugin-stores')}
                                        {Local === 'en_US' &&
                                          v.pur_amount === '' &&
                                          __('-', 'cec-plugin-stores')}
                                      </li>
                                      <li
                                        className='d-none d-lg-block'
                                        data-title='紅利折抵'>
                                        {BonusPointRedeemValue}
                                        {BonusPointRedeemValue !== '' &&
                                          __('點', 'cec-plugin-stores')}
                                      </li>
                                      <li data-title='獲得點數'>
                                        {BonusPointEarnValue}
                                        {BonusPointEarnValue !== '' &&
                                          __('點', 'cec-plugin-stores')}
                                        {v.isLoaded === true &&
                                          BonusPointEarnValue === '' &&
                                          __('-', 'cec-plugin-stores')}
                                      </li>
                                      <li
                                        className='d-none d-lg-block'
                                        data-title='發票號碼'>
                                        {v.einvoice_no !== '' &&
                                          v.einvoice_no}
                                        {v.einvoice_no === '' &&
                                          __('-', 'cec-plugin-stores')}
                                      </li>
                                      <li
                                        className='d-none d-lg-block'
                                        data-title='是否列印發票'>
                                        {v.isLoaded !== true &&
                                          __('-', 'cec-plugin-stores')}
                                        {v.einvoice_type === '2' &&
                                          __(
                                            '電子發票',
                                            'cec-plugin-stores',
                                          )}
                                        {/* __('非歸戶發票','cec-plugin-stores') */}
                                        {v.einvoice_type !== '2' &&
                                          v.einvoice_type !== '' &&
                                          __(
                                            '紙本發票',
                                            'cec-plugin-stores',
                                          )}
                                        {v.einvoice_type !== '2' &&
                                          v.einvoice_type === '' &&
                                          v.isLoaded === true &&
                                          __('-', 'cec-plugin-stores')}
                                      </li>
                                      <li
                                        className='d-none d-lg-block'
                                        data-title='是否中獎'>
                                        {diffdd === '未開獎' &&
                                          v.einvoice_type === '2' &&
                                          __('未開獎', 'cec-plugin-stores')}
                                        {diffdd === '未開獎' &&
                                          v.einvoice_type === '3' &&
                                          __(
                                            '請自行對獎',
                                            'cec-plugin-stores',
                                          )}
                                        {v.isLoaded !== true &&
                                          __('', 'cec-plugin-stores')}
                                        {v.einvoice_type === '' &&
                                          __('-', 'cec-plugin-stores')}
                                        {diffdd === '已開獎' &&
                                          v.einvoice_type === '3' &&
                                          __(
                                            '請自行對獎',
                                            'cec-plugin-stores',
                                          )}
                                        {diffdd === '已開獎' &&
                                          v.isLoaded === true &&
                                          v.einvoice_type === '2' &&
                                          v.win === '' &&
                                          __('未中獎', 'cec-plugin-stores')}
                                        {diffdd === '已開獎' &&
                                          v.isLoaded === true &&
                                          v.einvoice_type === '2' &&
                                          v.win === 'B' &&
                                          __(
                                            '無實體發票專屬獎',
                                            'cec-plugin-stores',
                                          )}
                                        {diffdd === '已開獎' &&
                                          v.isLoaded === true &&
                                          v.einvoice_type === '2' &&
                                          v.win === 'C' &&
                                          __(
                                            '無實體百萬元獎',
                                            'cec-plugin-stores',
                                          )}
                                        {diffdd === '已開獎' &&
                                          v.isLoaded === true &&
                                          v.einvoice_type === '2' &&
                                          v.win === 'A' &&
                                          __('特別獎', 'cec-plugin-stores')}
                                        {diffdd === '已開獎' &&
                                          v.isLoaded === true &&
                                          v.einvoice_type === '2' &&
                                          v.win === '0' &&
                                          __('特獎', 'cec-plugin-stores')}
                                        {diffdd === '已開獎' &&
                                          v.isLoaded === true &&
                                          v.einvoice_type === '2' &&
                                          v.win === '1' &&
                                          __('頭獎', 'cec-plugin-stores')}
                                        {diffdd === '已開獎' &&
                                          v.isLoaded === true &&
                                          v.einvoice_type === '2' &&
                                          v.win === '2' &&
                                          __('二獎', 'cec-plugin-stores')}
                                        {diffdd === '已開獎' &&
                                          v.isLoaded === true &&
                                          v.einvoice_type === '2' &&
                                          v.win === '3' &&
                                          __('三獎', 'cec-plugin-stores')}
                                        {diffdd === '已開獎' &&
                                          v.isLoaded === true &&
                                          v.einvoice_type === '2' &&
                                          v.win === '4' &&
                                          __('四獎', 'cec-plugin-stores')}
                                        {diffdd === '已開獎' &&
                                          v.isLoaded === true &&
                                          v.einvoice_type === '2' &&
                                          v.win === '5' &&
                                          __('五獎', 'cec-plugin-stores')}
                                        {diffdd === '已開獎' &&
                                          v.isLoaded === true &&
                                          v.einvoice_type === '2' &&
                                          v.win === '6' &&
                                          __('六獎', 'cec-plugin-stores')}
                                      </li>
                                    </ul>
                                    <div
                                      className='order-detail-info collapse'
                                      id={`order-detail-${v.pur_id}`}>
                                      <div className='card'>
                                        <div className='card-body'>
                                          <div className='card points-list'>
                                            <h5 className='card-header'>
                                              {__(
                                                '點數明細',
                                                'cec-plugin-stores',
                                              )}
                                            </h5>
                                            <div className='card-body p-0'>
                                              <ul className='list-unstyled'>
                                                <li className='d-flex align-items-center justify-content-between text-navy p-4 border-light border-bottom'>
                                                  <p className='p text-left mb-0'>
                                                    {__(
                                                      '本次扣抵',
                                                      'cec-plugin-stores',
                                                    )}
                                                  </p>
                                                  <p className='p text-right text-danger mb-0'>
                                                    {BonusPointRedeemValue}
                                                    {BonusPointRedeemValue !==
                                                      '' &&
                                                      __(
                                                        '點',
                                                        'cec-plugin-stores',
                                                      )}
                                                  </p>
                                                </li>
                                                <li className='d-flex align-items-center justify-content-between text-navy p-4 border-light border-bottom'>
                                                  <p className='p text-left mb-0'>
                                                    {__(
                                                      '本次回饋點數總計',
                                                      'cec-plugin-stores',
                                                    )}
                                                  </p>
                                                  <p className='p text-right text-primary mb-0'>
                                                    {BonusPointEarnValue}
                                                    {BonusPointEarnValue !==
                                                      '' &&
                                                      __(
                                                        '點',
                                                        'cec-plugin-stores',
                                                      )}
                                                    {v.isLoaded === true &&
                                                      BonusPointEarnValue ===
                                                        '' &&
                                                      __(
                                                        '-',
                                                        'cec-plugin-stores',
                                                      )}
                                                  </p>
                                                </li>
                                              </ul>
                                            </div>
                                          </div>
                                          <div className='card order-list'>
                                            <h5 className='card-header text-left'>
                                              <span className='d-block'>
                                                {__(
                                                  '交易明細： ',
                                                  'cec-plugin-stores',
                                                )}
                                                {v.pur_transactionTime}
                                              </span>
                                              <span className='d-block'>
                                                {__(
                                                  '發票捐贈： ',
                                                  'cec-plugin-stores',
                                                )}
                                                {![2, 3].includes(
                                                  parseInt(
                                                    v.einvoice_type,
                                                    10,
                                                  ),
                                                ) ? (
                                                  '-'
                                                ) : (
                                                  <Fragment>
                                                    {v.donation === 1
                                                      ? __(
                                                          '有',
                                                          'cec-plugin-stores',
                                                        )
                                                      : __(
                                                          '無',
                                                          'cec-plugin-stores',
                                                        )}
                                                  </Fragment>
                                                )}
                                              </span>
                                              <span className='d-block'>
                                                {__(
                                                  '備註： ',
                                                  'cec-plugin-stores',
                                                )}
                                                {v.pur_remarks !== '' &&
                                                  v.pur_remarks}
                                                {v.pur_remarks === '' &&
                                                  __(
                                                    '-',
                                                    'cec-plugin-stores',
                                                  )}
                                              </span>
                                            </h5>
                                            <div className='card-body p-0'>
                                              <div
                                                className='flex-table'
                                                data-theme='light'>
                                                <div className='thead tbody'>
                                                  {_.map(
                                                    purItems,
                                                    (item) => {
                                                      const itemName = _.get(
                                                        item,
                                                        'itemName',
                                                        [],
                                                      )
                                                      const qty = _.get(
                                                        item,
                                                        'qty',
                                                        [],
                                                      )
                                                      return (
                                                        <ul className='table-row'>
                                                          <li
                                                            className='text-left'
                                                            data-title='品名'>
                                                            {itemName}
                                                          </li>
                                                          <li data-title='數量'>
                                                            {qty}
                                                          </li>
                                                          <li
                                                            className='text-center'
                                                            data-title='金額'>
                                                            {_.get(
                                                              item,
                                                              'amount',
                                                              0,
                                                            )}
                                                          </li>
                                                        </ul>
                                                      )
                                                    },
                                                  )}
                                                  <ul className='table-row'>
                                                    <li className='text-lg-left d-none d-lg-block'>
                                                      {' '}
                                                    </li>
                                                    <li>
                                                      {__(
                                                        '小計',
                                                        'cec-plugin-stores',
                                                      )}
                                                    </li>
                                                    <li
                                                      className='text-center'
                                                      data-title='金額'>
                                                      {purNetAmount}
                                                    </li>
                                                  </ul>
                                                  {_.map(
                                                    purTenders,
                                                    (tender) => {
                                                      return (
                                                        <ul className='table-row'>
                                                          <li className='text-center'>
                                                            &nbsp;
                                                          </li>
                                                          <li>
                                                            {__(
                                                              _.get(
                                                                tender,
                                                                'tenderName',
                                                                '-',
                                                              ),
                                                              'cec-plugin-stores',
                                                            )}
                                                          </li>
                                                          <li className='text-center'>
                                                            {_.toInteger(
                                                              _.get(
                                                                tender,
                                                                'amount',
                                                                0,
                                                              ),
                                                            )}
                                                          </li>
                                                        </ul>
                                                      )
                                                    },
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )
                            })}
                        </Spin>
                      </div>
                      {/* <div className="text-center mt-5 my-lg-5"><a className="h6 btn btn-success rounded-pill px-5 py-2 mb-0" role="button" href="#">看更多</a></div> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className='row no-gutters mx-n3 mb-4'>
                <div className='col-lg-3 px-3'>
                  <div className='card border-0 shadow-0 h-100'>
                    <div className='card-body d-flex justify-content-center align-items-center pb-0 pt-5 p-lg-5'>
                      <h5 className='h4 text-navy text-center'>
                        {__('注意事項', 'cec-plugin-stores')}
                      </h5>
                    </div>
                  </div>
                </div>
                <div className='col-lg-9 px-3'>
                  <div className='card border-0 shadow-0 h-100'>
                    <div className='card-body p-5'>
                      <p className='h6 text-navy text-justify'>
                        {__(
                          '如您發現姓名或生日與您申請資料不符，請與客服中心聯絡作資料的修改，以確保會員資料的正確性。',
                          'cec-plugin-stores',
                        )}
                      </p>
                      <p className='h6 text-navy text-justify'>
                        {__(
                          '客服中心：市話 0809-001-365 / 手機(02)8006-9999 ',
                          'cec-plugin-stores',
                        )}
                      </p>
                      <p className='h6 text-navy text-justify'>
                        {__(
                          '※ 由於促銷目錄為提前印製，故於網站更新個人地址後，目錄寄件資料更新約需30個工作天，造成您不便之處盼您見諒！！',
                          'cec-plugin-stores',
                        )}
                      </p>
                      <p className='h6 text-navy text-justify'>
                        {__(
                          '※ 如需取消促銷目錄寄送的服務，請與客服中心聯絡，將有專人為您提供服務。',
                          'cec-plugin-stores',
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
    )
  }
}

const test_list = [
  {
    id: 1050,
    pur_amount: 100,
    pur_dt: '2020-07-26',
    pur_id: 1050,
    pur_store: '測試店',
    pur_storeId: '888',
    pur_posId: 1,
  },
  {
    id: 1049,
    pur_amount: 100,
    pur_dt: '2020-07-26',
    pur_id: 1049,
    pur_store: '測試店',
    pur_storeId: '888',
    pur_posId: 1,
  },
  {
    id: 1048,
    pur_amount: 100,
    pur_dt: '2020-07-26',
    pur_id: 1048,
    pur_store: '測試店',
    pur_storeId: '888',
    pur_posId: 1,
  },
  {
    id: 1047,
    pur_amount: 100,
    pur_dt: '2020-07-26',
    pur_id: 1047,
    pur_store: '測試店',
    pur_storeId: '888',
    pur_posId: 1,
  },
  {
    id: 1046,
    pur_amount: 100,
    pur_dt: '2020-07-26',
    pur_id: 1046,
    pur_store: '測試店',
    pur_storeId: '888',
    pur_posId: 1,
  },
  {
    id: 1045,
    pur_amount: 100,
    pur_dt: '2020-07-26',
    pur_id: 1045,
    pur_store: '測試店',
    pur_storeId: '888',
    pur_posId: 1,
  },
  {
    id: 1044,
    pur_amount: 100,
    pur_dt: '2020-07-26',
    pur_id: 1044,
    pur_store: '測試店',
    pur_storeId: '888',
    pur_posId: 1,
  },
  {
    id: 1043,
    pur_amount: 100,
    pur_dt: '2020-07-26',
    pur_id: 1043,
    pur_store: '測試店',
    pur_storeId: '888',
    pur_posId: 1,
  },
  {
    id: 1042,
    pur_amount: 100,
    pur_dt: '2020-07-26',
    pur_id: 1042,
    pur_store: '測試店',
    pur_storeId: '888',
    pur_posId: 1,
  },
  {
    id: 1040,
    pur_amount: 100,
    pur_dt: '2020-07-26',
    pur_id: 1040,
    pur_store: '測試店',
    pur_storeId: '888',
    pur_posId: 1,
  },
]

const test_detail = [
  {
    id: '1050',
    pur_transactionTime: '2020-07-26 20:00:10',
    pur_discount: '0.000',
    pur_accounts: [
      {
        id: '1',
        name: '紅利點數',
        earnValue: 99,
        redeemValue: 0,
        balance: 19979,
      },
    ],
    pur_items: [
      {
        itemId: '1806328',
        itemName: '雪山啤酒Can473ml',
        hierarchyId: '10100',
        amount: 100,
        price: 100,
        netPrice: 100,
        qty: 1,
      },
    ],
    pur_tenders: [
      {
        tenderId: 1,
        tenderName: 'Cash',
        amount: '99.000',
      },
      {
        tenderId: 16,
        tenderName: '紅利兌換',
        amount: '1.000',
      },
    ],
    pur_coupons: null,
    pur_trantypeid: '20',
    pur_totalamount: '100.000',
    pur_netamount: 100,
    einvoice_no: 'DS99767892',
    redemption_status: 1,
    einvoice_type: '2',
    donation: 0,
    win: '6',
    prize_amount: 200,
  },
  {
    id: '1049',
    pur_transactionTime: '2020-07-26 20:00:10',
    pur_discount: '0.000',
    pur_accounts: [
      {
        id: '1',
        name: '紅利點數',
        earnValue: 99,
        redeemValue: 0,
        balance: 19979,
      },
    ],
    pur_items: [
      {
        itemId: '1806328',
        itemName: '雪山啤酒Can473ml',
        hierarchyId: '10100',
        amount: 100,
        price: 100,
        netPrice: 100,
        qty: 1,
      },
    ],
    pur_tenders: [
      {
        tenderId: 1,
        tenderName: 'Cash',
        amount: '99.000',
      },
      {
        tenderId: 16,
        tenderName: '紅利兌換',
        amount: '1.000',
      },
    ],
    pur_coupons: null,
    pur_trantypeid: '20',
    pur_totalamount: '100.000',
    pur_netamount: 100,
    einvoice_no: 'DS99767892',
    redemption_status: 1,
    einvoice_type: '2',
    donation: 0,
    win: '6',
    prize_amount: 200,
  },
  {
    id: '1048',
    pur_transactionTime: '2020-07-26 20:00:10',
    pur_discount: '0.000',
    pur_accounts: [
      {
        id: '1',
        name: '紅利點數',
        earnValue: 99,
        redeemValue: 0,
        balance: 19979,
      },
    ],
    pur_items: [
      {
        itemId: '1806328',
        itemName: '雪山啤酒Can473ml',
        hierarchyId: '10100',
        amount: 100,
        price: 100,
        netPrice: 100,
        qty: 1,
      },
    ],
    pur_tenders: [
      {
        tenderId: 1,
        tenderName: 'Cash',
        amount: '99.000',
      },
      {
        tenderId: 16,
        tenderName: '紅利兌換',
        amount: '1.000',
      },
    ],
    pur_coupons: null,
    pur_trantypeid: '20',
    pur_totalamount: '100.000',
    pur_netamount: 100,
    einvoice_no: 'DS99767892',
    redemption_status: 1,
    einvoice_type: '2',
    donation: 0,
    win: '6',
    prize_amount: 200,
  },
  {
    id: '1047',
    pur_transactionTime: '2020-07-26 20:00:10',
    pur_discount: '0.000',
    pur_accounts: [
      {
        id: '1',
        name: '紅利點數',
        earnValue: 99,
        redeemValue: 0,
        balance: 19979,
      },
    ],
    pur_items: [
      {
        itemId: '1806328',
        itemName: '雪山啤酒Can473ml',
        hierarchyId: '10100',
        amount: 100,
        price: 100,
        netPrice: 100,
        qty: 1,
      },
    ],
    pur_tenders: [
      {
        tenderId: 1,
        tenderName: 'Cash',
        amount: '99.000',
      },
      {
        tenderId: 16,
        tenderName: '紅利兌換',
        amount: '1.000',
      },
    ],
    pur_coupons: null,
    pur_trantypeid: '20',
    pur_totalamount: '100.000',
    pur_netamount: 100,
    einvoice_no: 'DS99767892',
    redemption_status: 1,
    einvoice_type: '2',
    donation: 0,
    win: '6',
    prize_amount: 200,
  },
  {
    id: '1046',
    pur_transactionTime: '2020-07-26 20:00:10',
    pur_discount: '0.000',
    pur_accounts: [
      {
        id: '1',
        name: '紅利點數',
        earnValue: 99,
        redeemValue: 0,
        balance: 19979,
      },
    ],
    pur_items: [
      {
        itemId: '1806328',
        itemName: '雪山啤酒Can473ml',
        hierarchyId: '10100',
        amount: 100,
        price: 100,
        netPrice: 100,
        qty: 1,
      },
    ],
    pur_tenders: [
      {
        tenderId: 1,
        tenderName: 'Cash',
        amount: '99.000',
      },
      {
        tenderId: 16,
        tenderName: '紅利兌換',
        amount: '1.000',
      },
    ],
    pur_coupons: null,
    pur_trantypeid: '20',
    pur_totalamount: '100.000',
    pur_netamount: 100,
    einvoice_no: 'DS99767892',
    redemption_status: 1,
    einvoice_type: '2',
    donation: 0,
    win: '6',
    prize_amount: 200,
  },
  {
    id: '1045',
    pur_transactionTime: '2020-07-26 20:00:10',
    pur_discount: '0.000',
    pur_accounts: [
      {
        id: '1',
        name: '紅利點數',
        earnValue: 99,
        redeemValue: 0,
        balance: 19979,
      },
    ],
    pur_items: [
      {
        itemId: '1806328',
        itemName: '雪山啤酒Can473ml',
        hierarchyId: '10100',
        amount: 100,
        price: 100,
        netPrice: 100,
        qty: 1,
      },
    ],
    pur_tenders: [
      {
        tenderId: 1,
        tenderName: 'Cash',
        amount: '99.000',
      },
      {
        tenderId: 16,
        tenderName: '紅利兌換',
        amount: '1.000',
      },
    ],
    pur_coupons: null,
    pur_trantypeid: '20',
    pur_totalamount: '100.000',
    pur_netamount: 100,
    einvoice_no: 'DS99767892',
    redemption_status: 1,
    einvoice_type: '2',
    donation: 0,
  },
  {
    id: '1044',
    pur_transactionTime: '2020-07-26 20:00:10',
    pur_discount: '0.000',
    pur_accounts: [
      {
        id: '1',
        name: '紅利點數',
        earnValue: 99,
        redeemValue: 0,
        balance: 19979,
      },
    ],
    pur_items: [
      {
        itemId: '1806328',
        itemName: '雪山啤酒Can473ml',
        hierarchyId: '10100',
        amount: 100,
        price: 100,
        netPrice: 100,
        qty: 1,
      },
    ],
    pur_tenders: [
      {
        tenderId: 1,
        tenderName: 'Cash',
        amount: '99.000',
      },
      {
        tenderId: 16,
        tenderName: '紅利兌換',
        amount: '1.000',
      },
    ],
    pur_coupons: null,
    pur_trantypeid: '20',
    pur_totalamount: '100.000',
    pur_netamount: 100,
    einvoice_no: 'DS99767892',
    redemption_status: 1,
    einvoice_type: '2',
    donation: 0,
  },
  {
    id: '1043',
    pur_transactionTime: '2020-07-26 20:00:10',
    pur_discount: '0.000',
    pur_accounts: [
      {
        id: '1',
        name: '紅利點數',
        earnValue: 99,
        redeemValue: 0,
        balance: 19979,
      },
    ],
    pur_items: [
      {
        itemId: '1806328',
        itemName: '雪山啤酒Can473ml',
        hierarchyId: '10100',
        amount: 100,
        price: 100,
        netPrice: 100,
        qty: 1,
      },
    ],
    pur_tenders: [
      {
        tenderId: 1,
        tenderName: 'Cash',
        amount: '99.000',
      },
      {
        tenderId: 16,
        tenderName: '紅利兌換',
        amount: '1.000',
      },
    ],
    pur_coupons: null,
    pur_trantypeid: '20',
    pur_totalamount: '100.000',
    pur_netamount: 100,
    einvoice_no: 'DS99767892',
    redemption_status: 1,
    einvoice_type: '2',
    donation: 0,
  },
  {
    id: '1042',
    pur_transactionTime: '2020-07-26 20:00:10',
    pur_discount: '0.000',
    pur_accounts: [
      {
        id: '1',
        name: '紅利點數',
        earnValue: 99,
        redeemValue: 0,
        balance: 19979,
      },
    ],
    pur_items: [
      {
        itemId: '1806328',
        itemName: '雪山啤酒Can473ml',
        hierarchyId: '10100',
        amount: 100,
        price: 100,
        netPrice: 100,
        qty: 1,
      },
    ],
    pur_tenders: [
      {
        tenderId: 1,
        tenderName: 'Cash',
        amount: '99.000',
      },
      {
        tenderId: 16,
        tenderName: '紅利兌換',
        amount: '1.000',
      },
    ],
    pur_coupons: null,
    pur_trantypeid: '20',
    pur_totalamount: '100.000',
    pur_netamount: 100,
    einvoice_no: 'DS99767892',
    redemption_status: 1,
    einvoice_type: '2',
    donation: 0,
  },
  {
    id: '1040',
    pur_transactionTime: '2020-07-26 20:00:10',
    pur_discount: '0.000',
    pur_accounts: [
      {
        id: '1',
        name: '紅利點數',
        earnValue: 99,
        redeemValue: 0,
        balance: 19979,
      },
    ],
    pur_items: [
      {
        itemId: '1806328',
        itemName: '雪山啤酒Can473ml',
        hierarchyId: '10100',
        amount: 100,
        price: 100,
        netPrice: 100,
        qty: 1,
      },
    ],
    pur_tenders: [
      {
        tenderId: 1,
        tenderName: 'Cash',
        amount: '99.000',
      },
      {
        tenderId: 16,
        tenderName: '紅利兌換',
        amount: '1.000',
      },
    ],
    pur_coupons: null,
    pur_trantypeid: '20',
    pur_totalamount: '100.000',
    pur_netamount: 100,
    einvoice_no: 'DS99767892',
    redemption_status: 1,
    einvoice_type: '2',
    donation: 0,
  },
]

const test = [
  {
    pur_amount: 25,
    pur_dt: '2020-07-24 14:09:00',
    pur_id: 1324310059,
    pur_redeem_pts: 0,
    pur_reward_pts: 50,
    pur_store: '北投店',
    don_fl: 0,
    inv_code: 'BS75554229',
    inv_date: '2020-06-27 00:00:00',
    inv_id: 336502898,
    inv_type: '電子發票(有列印)',
    inv_win_code: '',
    inv_win_flag: 0,
  },
  {
    pur_amount: 256,
    pur_dt: '2020-07-19 18:54:00',
    pur_id: 1322730315,
    pur_redeem_pts: 0,
    pur_reward_pts: 512,
    pur_store: '重新店',
    don_fl: 0,
    inv_code: 'BS75554228',
    inv_date: '2020-06-27 00:00:00',
    inv_id: 336502877,
    inv_type: '電子發票(有列印)',
    inv_win_code: '',
    inv_win_flag: 0,
  },
]

// 編輯器
const listGrid = { gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 4 }
export class UserPaymentOcaEditor extends Component {
  formRef = React.createRef()
  state = {
    listInfo: _.cloneDeep(defaultListInfo),
  }
  componentDidMount() {
    AppHelper.updateConfig()
    console.log('kkk', this.props.attributes)

    //this.formRef.current.setFieldsValue(this.props.attributes)
  }
  render() {
    const listInfo = this.state.listInfo
    const options = _.get(this, 'props.app.options', {})
    console.log('editor', this.props)

    return (
      <div className='wp-block-cec-vulcan-block-catalogue-list-editor'>
        <h2>OCA-消費記錄</h2>
        <Form ref={this.formRef} name='basic' className='basicForm' />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/blocks/users/user-payment-oca.js